import { BasketTradeInQuote } from "../components/TradeInModal/Confirmation/util/getBasketQuotes";

export type TradeInQuotesResponse = {
  status: number;
  error?: string;
  quote?: BasketTradeInQuote;
};

export const getTradeInQuotesFromBff = async (
  baseUrl: string,
  basketId: string,
): Promise<TradeInQuotesResponse> => {
  const url = `${baseUrl}/api/v1/baskets/${basketId}/trade-in-quotes`;
  return await fetch(url)
    .then(async function (response: Response) {
      const { status } = response;
      if (response.ok && status >= 200 && response.status <= 299) {
        return { status: status, quote: await response.json() };
      }
      return { status: status, error: "Get basket trade in quote failed" };
    })
    .catch(() => {
      return { status: 400, error: "Get basket trade in quote failed" };
    });
};

export const getTradeInQuotes = async (baseUrl: string) => {
  const url = `${baseUrl}/trade-in-quotes`;
  try {
    const response = await fetch(url, {
      method: "GET",
      credentials: "include",
      headers: {
        "x-api-client-id": "electricals",
      },
    });
    const { status } = response;

    if (status >= 200 && status <= 299) {
      return { status: status, quote: await response.json() };
    }
    return { status: status, error: "Get basket trade in quote failed" };
  } catch (e) {
    return { status: 400, error: "Get basket trade in quote failed" };
  }
};
